import { useEffect, useState } from "react";
import axios from "axios";
import { NICHES } from "../data/niches";
import { POSTS } from "../data/posts";
import { SERVICES } from "../data/services";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = {};

const fetchContent = async (key) => {
  if (cache[key] === undefined) {
    cache[key] = axios.get(`${API}/content/${key}`).then((r) => r.data.data).catch(() => null);
  }
  return cache[key];
};

export const invalidateContent = (key) => { delete cache[key]; };

// Merge admin overrides (no icons) onto the code defaults (which carry icons/accents).
export const mergeNiches = (override) => {
  if (!Array.isArray(override)) return NICHES;
  return NICHES.map((n) => {
    const o = override.find((x) => x.slug === n.slug);
    return o ? { ...n, ...o, icon: n.icon, accent: n.accent } : n;
  });
};

export const mergePosts = (override) => (Array.isArray(override) && override.length ? override : POSTS);

// Services keep their icon/layout from code; wording comes from the override.
export const mergeServices = (override) => {
  if (!Array.isArray(override)) return SERVICES;
  return SERVICES.map((s) => {
    const o = override.find((x) => x.slug === s.slug);
    return o ? { ...s, ...o, icon: s.icon, accent: s.accent, span: s.span, tint: s.tint, iconColor: s.iconColor } : s;
  });
};

// Returns the merged list; `.loaded` is false until the admin overrides have been checked.
const useMerged = (key, defaults, merge) => {
  const [state, setState] = useState({ list: defaults, loaded: false });
  useEffect(() => {
    let alive = true;
    fetchContent(key).then((d) => { if (alive) setState({ list: merge(d), loaded: true }); });
    return () => { alive = false; };
  }, [key, defaults, merge]);
  const list = state.list;
  list.loaded = state.loaded;
  return list;
};

export const useNiches = () => useMerged("niches", NICHES, mergeNiches);
export const usePosts = () => useMerged("posts", POSTS, mergePosts);
export const useServices = () => useMerged("services", SERVICES, mergeServices);
